import axios from "../api";
import { CRYPTO_TOKEN_SECRET_KEY } from "../config";
import CryptoJS from "crypto-js";
 
const getAuthToken = () => {
    const decryptedData = CryptoJS.AES.decrypt(
        localStorage.getItem("token"),
        CRYPTO_TOKEN_SECRET_KEY
    ).toString(CryptoJS.enc.Utf8);
    return decryptedData;
};

export const allLoginSessionsAction = async (startDate, endDate, perPage, page) => {
    const authToken = getAuthToken();
    const headers = {
        Authorization: `Bearer ${authToken}`,
    };
    return new Promise((resolve, reject) => {
        axios
          .get(
            `/api/login-sessions/allLoginSessions?startDate=${startDate}&endDate=${endDate}&perPage=${perPage}&page=${page}`,
            {
              headers: headers,
            }
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
    });
};
